import createDependentCollector from "./utils/create-dependent-collector";

const getForTabbedConferenceSelection = createDependentCollector(["ConferenceRankV2"]);

export default getForTabbedConferenceSelection;
